export type DepartmentMultiSelectMode =
  | 'pooler-assignment'
  | 'edit-read-write'
  | 'edit-blacklist-inverted';

export type DepartmentMultiSelectColumn =
  | 'pooler-assigned'
  | 'pooler-direct-accept'
  | 'read'
  | 'write'
  | 'blacklist-inverted';

export type DepartmentMultiSelectColumnConfiguration = {
  dependsOn?: DepartmentMultiSelectColumn;
  icon: string;
  tooltipKey: string;
};

export type ClearSelectionEvent = {
  type: 'clear';
};

export type SelectDepartmentsEvent = {
  type: 'changed';
  departmentIds: string[];
  enabled: boolean;
  columns: DepartmentMultiSelectColumn[];
};

export type SelectAllEvent = {
  type: 'select_all';
  enabled: boolean;
  columns: DepartmentMultiSelectColumn[];
};

export type DepartmentSelectionEvent =
  | SelectDepartmentsEvent
  | ClearSelectionEvent
  | SelectAllEvent;

export type SelectionByColumn = Map<DepartmentMultiSelectColumn, boolean>;
export type SelectionByDepartment = Map<string, SelectionByColumn>;

export type SelectionByColumnDTO = {
  [key in DepartmentMultiSelectColumn]?: boolean;
};

export type SelectionByDepartmentDTO = {
  [departmentId: string]: SelectionByColumnDTO;
};

export type DepartmentChangesDto = {
  mode: DepartmentMultiSelectMode;
  selection: SelectionByDepartmentDTO;
};

export type SelectionByColumnWithIntermediate = Map<
  DepartmentMultiSelectColumn,
  'selected' | 'indeterminate' | 'unselected'
>;
export type SelectionByOrganisation = Map<
  string,
  SelectionByColumnWithIntermediate
>;

export function convertSelectionByDepartmentToDTO(
  selection: SelectionByDepartment,
): SelectionByDepartmentDTO {
  const dto: SelectionByDepartmentDTO = {};

  for (const [departmentId, columnMap] of selection) {
    const columnDTO: Partial<SelectionByColumnDTO> = {};

    for (const [column, value] of columnMap) {
      columnDTO[column] = value;
    }

    dto[departmentId] = columnDTO as SelectionByColumnDTO;
  }

  return dto;
}
